import React from 'react'
import { CheckIcon } from '@heroicons/react/24/outline'
import { RepairAndInquiriesStatusEntity } from '../../../../customEntites/RepairAndInquiries.entity'

const CIRCLE_SIZE = 28
const ACTIVE_COLOR = '#218cda'
const COMPLETED_COLOR = '#16a34a'      // green-600
const COMPLETED_BG = '#dcfce7'         // green-100
const INACTIVE_COLOR = '#d1d5db'
const LINE_COLOR = '#e5e7eb'
const LABEL_OFFSET = 8

interface Props {
  statuses: RepairAndInquiriesStatusEntity[]
  currentStatusIndex: number
  lang: string | null
}

export const TicketStatusStepper = ({ statuses, currentStatusIndex, lang }: Props) => {
  return (
    <div
      className="mx-auto flex items-center"
      style={{ maxWidth: 480, paddingBottom: 28 }}
    >
      {statuses.map((status, i) => {
        const isPast = i < currentStatusIndex
        const isCurrent = i === currentStatusIndex
        const ringColor = isPast ? COMPLETED_COLOR : isCurrent ? ACTIVE_COLOR : INACTIVE_COLOR
        const labelColor = isPast ? COMPLETED_COLOR : isCurrent ? '#212121' : '#9ca3af'
        return (
          <React.Fragment key={status.id}>
            {i > 0 && (
              <div
                className="flex-1 h-px"
                style={{
                  background: isPast || isCurrent ? COMPLETED_COLOR : LINE_COLOR,
                  margin: '0 8px',
                  opacity: isPast || isCurrent ? 0.5 : 1,
                }}
              />
            )}
            <div
              className="relative shrink-0"
              style={{ width: CIRCLE_SIZE, height: CIRCLE_SIZE }}
            >
              <div
                className="rounded-full flex items-center justify-center"
                style={{
                  width: CIRCLE_SIZE,
                  height: CIRCLE_SIZE,
                  border: `2px solid ${ringColor}`,
                  background: isPast ? COMPLETED_BG : '#fff',
                }}
              >
                {isPast ? (
                  <CheckIcon style={{ width: 16, height: 16, color: COMPLETED_COLOR, strokeWidth: 3 }} />
                ) : isCurrent ? (
                  <div style={{ width: 8, height: 8, background: ACTIVE_COLOR, borderRadius: 2 }} />
                ) : (
                  <div style={{ width: 8, height: 8, background: INACTIVE_COLOR, borderRadius: '50%' }} />
                )}
              </div>
              {/* Label centered under the circle, overflow allowed */}
              <span
                className="text-xs"
                style={{
                  position: 'absolute',
                  top: CIRCLE_SIZE + LABEL_OFFSET,
                  left: '50%',
                  transform: 'translateX(-50%)',
                  whiteSpace: 'nowrap',
                  fontWeight: isCurrent || isPast ? 700 : 400,
                  color: labelColor,
                  fontFamily: '"Red Hat Display", sans-serif',
                }}
              >
                {lang === 'EN' ? status.name : status.nameDe}
              </span>
            </div>
          </React.Fragment>
        )
      })}
    </div>
  )
}
